'use strict'

const list = require('../../data/portal2/blocks/_index')
const _ = require('lodash')

let config = {}
let defConf = {}

try {
	defConf = require('../../data/portal2/blocks/default.config.json')
} catch(e) {e}
defConf = _.defaultsDeep(defConf, require('../../src/blocks/default.config.json'))

function importItem(b) {
	if (b.group) { return }

	try {
		config[b.name] = require('../../data/portal2/blocks/' + b.name + '/' + b.name + '.json')
	} catch(e)  {e}
	config[b.name] = _.defaultsDeep(
		config[b.name] || {},
		require('../../src/blocks/' + b.name + '/' + b.name + '.json')
	)

	config[b.name]._block = b.name
	config[b.name]._sections = b.sections
	config[b.name]._groups = b.groups
	if (!Array.isArray(config[b.name].widget)) {
		config[b.name].widget.default = defConf
		config[b.name].widget = [config[b.name].widget]
	} else {
		for (var i in config[b.name].widget) {
			config[b.name].widget[i].default = defConf
		}
	}
}

list.forEach(b => {
	if (b.group) {
		let multi
		try {
			multi = require('../../data/portal2/blocks/_multi-' + b.group)
		} catch(e) {
			multi = require('./_multi-' + b.group)
		}
		multi.forEach(b2 => {
			importItem(b2)
		})
	}

	importItem(b)
})

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./src/blocks/_index.js
// module id = 268
// module chunks = 0